enum HttpStatusCode {
  Ok = 200,
  Redirect = 302,
  BadRequest = 400,
  Unauthorised = 401,
  Forbidden = 403,
  Locked = 423,
  InternalServerError = 500
}

export default HttpStatusCode;
